import type { ExpandableCatalog } from '@/data/models/catalog';
import { normalizeThresholdActionKeys } from '@/data/thresholdActions';
import type { RefrigerationUnitType } from '@/data/schemas';

const resolveThresholdActions = (actions: string[], catalog?: ExpandableCatalog): string[] => {
  const normalized = normalizeThresholdActionKeys(actions);
  if (!catalog) return normalized;
  const labelMap = new Map(catalog.options.map((option) => [option.id, option.label]));
  return normalized.map((action) => labelMap.get(action) ?? action);
};

export function buildUnitThresholdsText(
  unit: RefrigerationUnitType,
  actionsCatalog?: ExpandableCatalog
): string | undefined {
  if (!unit.technical.safety.detectors.thresholds.length) {
    return undefined;
  }
  return unit.technical.safety.detectors.thresholds
    .map((threshold) => {
      const unitLabel = threshold.unit === 'ppm' ? 'ppm' : '% LIE';
      const actions = resolveThresholdActions(threshold.actions ?? [], actionsCatalog);
      const valueLabel =
        threshold.value !== undefined && threshold.value !== null ? threshold.value : '—';
      return `${valueLabel} ${unitLabel}: ${actions.length ? actions.join(', ') : '—'}`;
    })
    .join('\n');
}

export function buildComponentsSummary(unit: RefrigerationUnitType): string | undefined {
  if (!unit.technical.components.length) return undefined;
  return unit.technical.components
    .map((component) => {
      const label = component.customLabel ?? component.type ?? 'Componente';
      const quantityLabel = component.quantity === undefined ? '' : ` x${component.quantity}`;
      const base = `${label}${quantityLabel}`;
      const capacity =
        component.capacityKw !== undefined && component.capacityKw !== null
          ? ` ${component.capacityKw} kW`
          : '';
      const location = component.location ? ` (${component.location})` : '';
      const notes = component.notes ? ` — ${component.notes}` : '';
      return `${base}${capacity}${location}${notes}`;
    })
    .join('\n');
}
